/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
import { Trans } from "react-i18next";
import GuideMember from "./GuideMember";

class GuideMembersTable extends Component {
    state = {
        sort_by: "trguidemainStep", // training name by default
        sort_dir: "desc",
    };

    trguidemainStep = "";
    trguidesubStep = "";
    trguidedescription = "";
    trguideaffectedDepartment = "";
    trguideresponsibleParty = "";
    trguideresponsiblepartytwo = "";
    trguideresponsiblepartythree = "";

    reOrder = (orderBy) => {
        let sort_dir = "asc";
        if (this.state.sort_dir === "asc") sort_dir = "desc";
        this.setState({
            sort_by: orderBy,
            sort_dir: sort_dir,
        });
    };

    setSotingClassNames = () => {

        this.trguidemainStep = "";
        this.trguidesubStep = "";
        this.trguidedescription = "";
        this.trguideaffectedDepartment = "";
        this.trguideresponsibleParty = "";
        this.trguideresponsiblepartytwo = "";
        this.trguideresponsiblepartythree = "";

        switch (this.state.sort_by) {
            case "trguidemainStep":
                this.trguidemainStep = `_${this.state.sort_dir}`;
                break;
            case "trguidesubStep":
                this.trguidesubStep = `_${this.state.sort_dir}`;
                break;
            case "trguidedescription":
                this.trguidedescription = `_${this.state.sort_dir}`;
                break;
            case "trguideaffectedDepartment":
                this.trguideaffectedDepartment = `_${this.state.sort_dir}`;
                break;
            case "trguideresponsibleParty":
                this.trguideresponsibleParty = `_${this.state.sort_dir}`;
                break;
            case "trguideresponsiblepartytwo":
                this.trguideresponsiblepartytwo = `_${this.state.sort_dir}`;
                break;
            case "trguideresponsiblepartythree":
                this.trguideresponsiblepartythree = `_${this.state.sort_dir}`;
                break;
            default:
                this.trguidemainStep = `_${this.state.sort_dir}`;
                break;
        }
    };

    renderData = () => {
        const sorted = this.props.data.sort((a, b) => {
            switch (this.state.sort_by) {
                case "trguidemainStep":
                    return this.state.sort_dir === "desc"
                        ? (a.mainStep ?? "").localeCompare(b.mainStep ?? "")
                        : (b.mainStep ?? "").localeCompare(a.mainStep ?? "");
                case "trguidesubStep":
                    return this.state.sort_dir === "desc"
                        ? (a.subStep ?? "").localeCompare(b.subStep ?? "")
                        : (b.subStep ?? "").localeCompare(a.subStep ?? "");
                case "trguidedescription":
                    return this.state.sort_dir === "desc"
                        ? (a.description ?? "").localeCompare(b.description ?? "")
                        : (b.description ?? "").localeCompare(a.description ?? "");
                case "trguideaffectedDepartment":
                    return this.state.sort_dir === "desc"
                        ? (a.affectedDepartment ?? "").localeCompare(b.affectedDepartment ?? "")
                        : (b.affectedDepartment ?? "").localeCompare(a.affectedDepartment ?? "");
                case "trguideresponsibleParty":
                    return this.state.sort_dir === "desc"
                        ? (a.responsibleParty ?? "").localeCompare(b.responsibleParty ?? "")
                        : (b.responsibleParty ?? "").localeCompare(a.responsibleParty ?? "");
                case "trguideresponsiblepartytwo":
                    return this.state.sort_dir === "desc"
                        ? (a.gsc_responsiblepartytwo ?? "").localeCompare(b.gsc_responsiblepartytwo ?? "")
                        : (b.gsc_responsiblepartytwo ?? "").localeCompare(a.gsc_responsiblepartytwo ?? "");
                case "trguideresponsiblepartythree":
                    return this.state.sort_dir === "desc"
                        ? (a.gsc_responsiblepartythree ?? "").localeCompare(b.gsc_responsiblepartythree ?? "")
                        : (b.gsc_responsiblepartythree ?? "").localeCompare(a.gsc_responsiblepartythree ?? "");
                default:
                    return this.state.sort_dir === "desc"
                        ? (a.mainStep ?? "").localeCompare(b.mainStep ?? "")
                        : (b.mainStep ?? "").localeCompare(a.mainStep ?? "");
            }
        });

        return sorted.map((m) => {
            return <GuideMember key={m.guideCenterId} mem={m} />;
        });
    };

    render() {
        this.setSotingClassNames();
        return (
            <div
                className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
                id="kayitliEgitimler"
                style={{ display: "block" }}
            >
                <table
                    className="table display responsive dataTable no-footer dtr-none collapsed"
                    id="dataTablePersonel"
                >
                    <thead>
                        <tr>
                            <th
                                onClick={() => this.reOrder("trName")}
                                className={`all sorting${this.trguidemainStep}`}
                            >
                                <div className="tableTitle">
                                    <Trans desc="guidemainStep">guidemainStep</Trans>
                                </div>
                            </th>
                            <DesktopBreakpoint>
                                <th
                                    onClick={() => this.reOrder("trguidesubStep")}
                                    className={`desktop sorting${this.trguidesubStep}`}
                                >
                                    <div className="tableTitle">
                                        <Trans desc="guidesubStep">guidesubStep</Trans>
                                    </div>
                                </th>
                                <th
                                    onClick={() => this.reOrder("trguidedescription")}
                                    className={`desktop sorting${this.trguidedescription}`}
                                >
                                    <div className="tableTitle">
                                        <Trans desc="guidedescription">guidedescription</Trans>
                                    </div>
                                </th>
                                <th
                                    onClick={() => this.reOrder("trguideaffectedDepartment")}
                                    className={`desktop sorting${this.trguideaffectedDepartment}`}
                                >
                                    <div className="tableTitle">
                                        <Trans desc="guideaffectedDepartment">guideaffectedDepartment</Trans>
                                    </div>
                                </th>
                                <th
                                    onClick={() => this.reOrder("trguideresponsibleParty")}
                                    className={`desktop sorting${this.trguideresponsibleParty}`}
                                >
                                    <div className="tableTitle">
                                        <Trans desc="guideresponsibleParty">guideresponsibleParty</Trans>
                                    </div>
                                </th>
                                <th
                                    onClick={() => this.reOrder("trguideresponsiblepartytwo")}
                                    className={`desktop sorting${this.trguideresponsiblepartytwo}`}
                                >
                                    <div className="tableTitle">
                                        <Trans desc="guideresponsiblepartytwo">guideresponsiblepartytwo</Trans>
                                    </div>
                                </th>
                                <th
                                    onClick={() => this.reOrder("trguideresponsiblepartythree")}
                                    className={`desktop sorting${this.trguideresponsiblepartythree}`}
                                >
                                    <div className="tableTitle">
                                        <Trans desc="guideresponsiblepartythree">guideresponsiblepartythree</Trans>
                                    </div>
                                </th>
                            </DesktopBreakpoint>
                        </tr>
                    </thead>
                    <tbody>
                        {this.renderData()}
                    </tbody>
                </table>
            </div>
        );
    }
}

export default GuideMembersTable;
